import styled from '@emotion/styled';
import { useDiscovery } from '../context';
import FilterName from './FilterName';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilterNameContainer = () => {
  const { filters, selectedFilterKey, selectFilter, pendingValues } = useDiscovery();

  return (
    <Wrapper>
      {filters.map(filter => (
        <FilterName
          key={filter.key}
          isSelected={filter.key === selectedFilterKey}
          isHighLighted={
            Array.isArray(pendingValues[filter.key])
              ? (pendingValues[filter.key] as any[]).length > 0
              : pendingValues[filter.key] !== undefined
          }
          onClick={() => selectFilter(filter.key)}
        >
          {filter.label}
        </FilterName>
      ))}
    </Wrapper>
  );
};

export default FilterNameContainer;
